import axios from "axios";
import storage from "redux-persist/lib/storage";
import { OrderPayload } from "../interfaces/apiPayloads";

const MachineId = null;
const TypeMachine = 4;

export const establishmentAxiosInstance = axios.create({});

establishmentAxiosInstance.interceptors.request.use(
  async (config: any) => {
    const establishementToken = await storage.getItem("establishementToken");

    config.headers = {
      ...config.headers,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Credentials": "true",
      CompanyId: localStorage.getItem("companyId") || "",
    };

    if (establishementToken) {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        Authorization: `bearer ${establishementToken}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const userAxiosInstance = axios.create({});

userAxiosInstance.interceptors.request.use(
  async (config: any) => {
    const accessToken = await storage.getItem("accessToken");

    config.headers = {
      ...config.headers,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Credentials": "true",
      CompanyId: localStorage.getItem("companyId") || "",
    };

    if (accessToken) {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        Authorization: `bearer ${accessToken}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const catalogueApi = {
  getCategories: (restaurantId?: number) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Category/GetCategoriesByIdPosAndTypeMachineId?MachineId=${MachineId}&TypeMachine=${TypeMachine}&EstablishmentId=${restaurantId}`
    );
  },

  getCategoryDetails: (categoryId: number, restaurantId?: number) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Category/GetCategoryDetailsByCategoryIdAndTypeMachine?CategoryId=${categoryId}&MachineId=${MachineId}&TypeMachine=${TypeMachine}&EstablishmentId=${restaurantId}`
    );
  },

  GetSubMenu: (
    categoryId: number,
    menuId: string,
    restaurantId?: number
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Menu/GetSubMenuByCategoryIdMenuIdAndTypeMachine?CategoryId=${categoryId}&MenuId=${menuId}&MachineId=${MachineId}&TypeMachine=${TypeMachine}&EstablishmentId=${restaurantId}`
    );
  },

  GetLevelsByMenuId: (
    categoryId: string | undefined,
    menuId: number,
    ListMenus: string,
    restaurantId?: number
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Menu/GetMenuDetailsByCategoryIdMenuIdAndTypeMachine?CategoryId=${categoryId}&MenuId=${menuId}&MachineId=${MachineId}&TypeMachine=${TypeMachine}&ListMenus=${ListMenus}&EstablishmentId=${restaurantId}`
    );
  },

  GetArticleComposition: (
    artileId: number,
    isLevelArticle: boolean,
    restaurantId?: number
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Article/GetArticleCompositionByArticleId?ArticleId=${artileId}&IsLevelArticle=${isLevelArticle}&EstablishmentId=${restaurantId}`
    );
  },

  GetArticleById: (
    artileId: number,
    categoryId: number,
    establishmentId: number
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Article/GetArticleByIdForFioEat?ArticleId=${artileId}&CategoryId=${categoryId}&EstablishmentId=${establishmentId}`
    );
  },

  GetMenuById: (artileId: number) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Menu/GetMenuByIdForFIOEat?MenuId=${artileId}`
    );
  },

  SavedOrder: (orderPayload: OrderPayload) => {
    const url =
      "http://showroom1.frenchinnov.fr:150/api/applis/Command/AnticipateExternCommand";

    return establishmentAxiosInstance.post(url, orderPayload);
  },

  getEstablishementToken: (restaurantId?: number) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/v1/getEstablishementToken?EstablishmentId=${restaurantId}`
    );
  },
};